<template>
    <div class="image-carousel">
        <!-- Slider main container -->
        <div class="swiper-container swiper-container--image-carousel">
            <!-- Additional required wrapper -->
            <div class="swiper-wrapper">
                <!-- Slides -->
                <div :key="index" class="swiper-slide w-1/3 object-fit" v-for="(image, index) in images"
                     v-html="image"></div>
            </div>
        </div>
        <svg class="button-next-slide" height="58" width="58" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fill-rule="evenodd" transform="translate(1 1)">
                <circle cx="28" cy="28" r="28" stroke="#1A3A1B"/>
                <path d="M44.5 27.4090909c-2.6337527 0-4.783079-2.0740762-4.9037476-4.6779974L39.5909091 22.5H38.5c0 2.0878518 1.0664091 3.9266303 2.6842526 5.0013609L12.5 27.5v1l28.6832482-.0006935C39.5659678 29.5741308 38.5 31.4125803 38.5 33.5h1.0909091l.0053433-.2310935c.1206686-2.6039212 2.2699949-4.6779974 4.9037476-4.6779974v-1.1818182z"
                      fill="#0B1B0C" fill-rule="nonzero"/>
            </g>
        </svg>
        <svg class="button-prev-slide" height="58" width="58" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" fill-rule="evenodd" transform="matrix(-1 0 0 1 57 1)">
                <circle cx="28" cy="28" r="28" stroke="#1A3A1B"/>
                <path d="M44.5 27.4090909c-2.6337527 0-4.783079-2.0740762-4.9037476-4.6779974L39.5909091 22.5H38.5c0 2.0878518 1.0664091 3.9266303 2.6842526 5.0013609L12.5 27.5v1l28.6832482-.0006935C39.5659678 29.5741308 38.5 31.4125803 38.5 33.5h1.0909091l.0053433-.2310935c.1206686-2.6039212 2.2699949-4.6779974 4.9037476-4.6779974v-1.1818182z"
                      fill="#0B1B0C" fill-rule="nonzero"/>
            </g>
        </svg>
    </div>
</template>

<script>
    import Swiper from 'swiper/bundle';

    export default {
        props: {
            images: {
                type: Array,
                default: () => []
            },
        },
        mounted() {
            const ImageCarousels = document.querySelectorAll('.image-carousel');
            for (let block of ImageCarousels) {
                const carContainer = block.getElementsByClassName('swiper-container--image-carousel')[0];
                const btnNext = block.getElementsByClassName('button-next-slide')[0];
                const btnPrev = block.getElementsByClassName('button-prev-slide')[0];
                new Swiper(carContainer, {
                    loop: false,
                    slidesPerView: 1,
                    spaceBetween: 20,

                    navigation: {
                        nextEl: btnNext,
                        prevEl: btnPrev,
                    },

                    breakpoints: {
                        650: {
                            slidesPerView: 2,
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 40,
                        },
                        1440: {
                            slidesPerView: 3,
                            spaceBetween: 60,
                        }
                    },
                });
            }
        }
    }
</script>